import { render } from "./ComingEventComponent.vue?vue&type=template&id=fef710ee&scoped=true"
import script from "./ComingEventComponent.vue?vue&type=script&lang=js"
export * from "./ComingEventComponent.vue?vue&type=script&lang=js"

import "./ComingEventComponent.vue?vue&type=style&index=0&id=fef710ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef710ee"]])

export default __exports__